module.exports = __webpack_public_path__ + "img/security-item-04.7d67c8ae.svg";